import { KEYCODES, CLASSES } from "@/scripts/helpers/constants";
import UslfSearch from "@/modules/components/uslf-search";

import { trackResponse } from "@/scripts/helpers/tracking";

export const usliSearchHeader = new UslfSearch("#searchForm");

const selectMask = $(".js-search-select-mask");
const userInfoAction = $(".js-user-info-combobox");
const mobileSearchAction = $(
  ".header-navbar__item--search .header-navbar__item-action"
);
const tabletSearchAction = $(".js-search-tablet-action");

const buttonSelectStateChangeSelector = $(".js-select-state-change");
const buttonSelectStateApplySelector = $(".js-select-state-apply");
const headerSearchNotificationSelector = $(".header-search__notification");
const selectStateOptionsSelector = $(".search__options-list-item");

const sendSelectState = data => {
  return fetch(`/api/v1/user/search/states`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ state: data })
  });
};

export const handleTrackMyAccount = () => {
  $(".user-info__options-list-link").on("click", function() {
    trackResponse({
      name: $(this).attr("data-name")
    });
  });
};

export const handleUserInfoAction = () => {
  userInfoAction.on("click", function() {
    mobileSearchAction.removeClass("is-active");
    $(this).toggleClass("is-open");
  });

  userInfoAction.on("keypress", function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.keyCode === KEYCODES.SPACE || e.keyCode === KEYCODES.ENTER) {
      mobileSearchAction.removeClass("is-active");
      $(this).toggleClass("is-open");
    }
  });
};

export const handleTabletSearch = () => {
  tabletSearchAction.on("click", function() {
    $(".header__nav").toggle();
    $(this).toggleClass(CLASSES.ACTIVE);
  });
};

export const handleComboboxClose = () => {
  $(document).on("click", function(event) {
    if (!$(event.target).closest(userInfoAction).length) {
      userInfoAction.removeClass("is-open");
    }

    if (!$(event.target).closest(selectMask).length) {
      selectMask.removeClass(CLASSES.ACTIVE);
    }
  });
};

export const handleSelectStateOptions = () => {
  const isSendDefaultState = $(".header-search").is(
    "[data-send-default-state='true']"
  );
  if (isSendDefaultState) {
    $(selectStateOptionsSelector).on("click", function() {
      const state = $(this).attr("data-value");
      sendSelectState(state);
    });
  }
};

export const handleSelectStateChange = func => {
  $(buttonSelectStateChangeSelector).on("click", function() {
    const notification = $(this).closest(".ui-notification");
    const search = $(this).closest(".header-search");
    const searchDesktop = search.find("#desktop-search");
    const searchMobile = search.find("#mobile-search");
    const searchState = search.find(".search__select-state");
    const searchInput = search.find(".search__select-state-input");

    setTimeout(function() {
      searchDesktop.addClass("focus-visible");
      searchMobile.addClass("focus-visible is-active");
      searchState.addClass("is-active");
      searchInput.focus();
    }, 500);

    notification.fadeOut();
    func();
  });
};

export const handleSelectStateApply = func => {
  $(buttonSelectStateApplySelector).on("click", function() {
    const notification = $(this).closest(".ui-notification");
    const search = $(this).closest(".header-search");
    const searchState = search.find(".search__select-state-body");
    const searchSelect = search.find(".search__select-state-input");
    const searchOptions = search.find(".search__select-state-input option");
    const defaultStateValue = notification
      .find("span[data-default-state-key]")
      .text()
      .trim();

    const defaultStateKey = notification
      .find("span[data-default-state-key]")
      .data("default-state-key");

    searchState.text(defaultStateValue);

    searchOptions.each(function() {
      $(this).removeAttr("selected");
    });

    searchSelect
      .find(`option[value="${defaultStateKey}"]`)
      .attr("selected", "selected");

    sendSelectState(notification.find("span").attr("data-default-state-key"));

    notification.fadeOut();
    func();
  });
};

export const headerHoverHandler = () => {
  const headerNavItemsSelector = $(".header__nav-item");

  if (headerNavItemsSelector) {
    headerNavItemsSelector.hover(
      function() {
        $(this).addClass(CLASSES.OPEN);
      },
      function() {
        $(this).removeClass(CLASSES.OPEN);
      }
    );
  }
};

const lastElementBlurHandler = (parentElement, lastElement) => {
  let categoriesLink = parentElement.find(lastElement);
  const lasCategoriesLinkIndex = categoriesLink.length - 1;
  const lastCategoriesLink = categoriesLink[lasCategoriesLinkIndex];

  $(lastCategoriesLink).blur(function() {
    parentElement.removeClass(CLASSES.OPEN);
  });
};

export const headerTabulationHandler = () => {
  const headerNavItemsSelector = $(".header__nav-item");

  if (headerNavItemsSelector) {
    headerNavItemsSelector.each(function() {
      const parentElement = $(this);

      parentElement.focus(function() {
        parentElement.addClass(CLASSES.OPEN);

        // handler for shift + tab press
        parentElement.keydown(function(event) {
          if (
            $(event.target).hasClass("header__nav-item") &&
            event.shiftKey &&
            event.key === "Tab"
          ) {
            parentElement.removeClass(CLASSES.OPEN);
          }
        });
      });

      // links without submenu
      parentElement.find(".header__nav-link").focus(function() {
        $(this)
          .parent()
          .addClass(CLASSES.OPEN);
      });

      parentElement.find(".header__nav-link").blur(function() {
        $(this)
          .parent()
          .removeClass(CLASSES.OPEN);
      });

      // if dropdown has 'tags' - remove is-open class after last tag lost focus
      if (parentElement.find(".tags").length) {
        let submenuTagsLink = parentElement.find(".tags .tags-list__link");
        lastElementBlurHandler(parentElement, submenuTagsLink);
      } else if (parentElement.find(".categories-list a").length) {
        // else - dropdown without tags - remove is-open class after last submenu lost focus
        let categoriesLink = parentElement.find(".categories-list a");
        lastElementBlurHandler(parentElement, categoriesLink);
      } else {
        let myAccountLinks = parentElement.find(
          ".user-info__options-list-link"
        );
        lastElementBlurHandler(parentElement, myAccountLinks);
      }
    });
  }
};

export const handleSelectStateClose = func => {
  headerSearchNotificationSelector.on("click", function(event) {
    if ($(event.target).closest(".js-notification-close").length) {
      document.cookie = "search_default_state_closed_popup=true";
      func();
    }
  });
};

export const handleSelectStateDisplay = () => {
  const headerNavSubmenuItemsSelector = $(".header__nav-item--submenu");

  const searchSelector = $(".search");
  const notificationTooltipSelector = $(".ui-notification--tooltip");

  if (headerNavSubmenuItemsSelector) {
    headerNavSubmenuItemsSelector.hover(
      function() {
        notificationTooltipSelector.hide();
      },
      function() {
        searchSelector.is(".select-lock") && notificationTooltipSelector.show();
      }
    );
  }
};
